module.exports = __webpack_public_path__ + "static/media/binSimpleGrey.292dcf53.svg";